import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { harrisburgPaConfig } from "./data";

export default function HarrisburgPaPage() {
  return <CityPageTemplate config={harrisburgPaConfig} />;
}